//Module Keys
let locales = {};

//Merge Views

//Main
import main from '../../views/main/lan/es';
locales = { ...locales, ...main };

import customerTab from "../../views/customerTab/lan/es";
locales = { ...locales, ...customerTab };

import trackerTab from '../../views/trackerTab/lan/es';
locales = { ...locales, ...trackerTab };

import createEditWorkOrder from '../../views/trackerTab/modals/createEditWorkOrder/lan/es'
locales = { ...locales, ...createEditWorkOrder };

import createEditCustomer from '../../views/customerTab/modals/createEditCustomer/lan/es'
locales = { ...locales, ...createEditCustomer };

import createEditContact from '../../views/contactTab/modals/createEditContact/lan/es';
locales = { ...locales, ...createEditContact };

import createEditLocation from '../../views/locationTab/modals/createEditLocation/lan/es';
locales = { ...locales, ...createEditLocation };

import customerSelector from '../../views/trackerTab/modals/customerSelector/lan/es';
locales = { ...locales, ...customerSelector };

import deleteCustomer from '../../views/customerTab/modals/deleteCustomer/lan/es';
locales = { ...locales, ...deleteCustomer };

import customerDetail from '../../views/customerDetail/lan/es';
locales = { ...locales, ...customerDetail };

import workOrderTab from '../../views/workOrderTab/lan/es'
locales = { ...locales, ...workOrderTab };

import contactTab from '../../views/contactTab/lan/es'
locales = { ...locales, ...contactTab };

import locationTab from '../../views/locationTab/lan/es';
locales = { ...locales, ...locationTab };

import schedule from '../../views/schedule/lan/es';
locales = { ...locales, ...schedule };

import advancedFilters from '../../views/workOrderTab/modals/advancedFilters/lan/es';
locales = { ...locales, ...advancedFilters };

import deleteLocation from '../../views/locationTab/modals/deleteLocation/lan/es';
locales = { ...locales, ...deleteLocation };

import deleteContact from '../../views/contactTab/modals/deleteContact/lan/es';
locales = { ...locales, ...deleteContact };

import importCustomers from '../../views/customerTab/modals/importCustomers/lan/es';
locales = { ...locales, ...importCustomers };

import driverSelector from '../../views/trackerTab/modals/driverSelector/lan/es';
locales = { ...locales, ...driverSelector };

import createEditWorkOrderSettings from '../../views/trackerTab/modals/createEditWorkOrder/views/settings/lan/es';
locales = { ...locales, ...createEditWorkOrderSettings };

import deleteWorkOrder from '../../views/trackerTab/modals/deleteWorkOrder/lan/es';
locales = { ...locales, ...deleteWorkOrder };

import createEditWorkOrderComments from '../../views/trackerTab/modals/createEditWorkOrder/views/comments/lan/es';
locales = { ...locales, ...createEditWorkOrderComments };

import createEditWorkOrderHistoryLogs from '../../views/trackerTab/modals/createEditWorkOrder/views/historyLogs/lan/es';
locales = { ...locales, ...createEditWorkOrderHistoryLogs };

import changeStatus from '../../views/trackerTab/modals/changeStatus/lan/es';
locales = { ...locales, ...changeStatus };

export default locales;